import {call, put, takeEvery} from 'redux-saga/effects';
import {logError} from '@yandex-int/pythia-libs/lib/rum';

import {showNotification} from 'client/common/store/actions/notifications';

import {
    clearAgencyClients,
    fetchAgencyClients,
    setAgencyClients,
    syncAgencyClients
} from 'client/common/store/reducers/user';

import {
    GetAgencyClientsResponse,
    SyncAgencyClientsResponse
} from 'client/common/utils/api-client/types';
import {
    syncAgencyClients as syncAgencyClientsRequest,
    getAgencyClients
} from 'client/common/utils/api-client/constructor';
import I18N from 'assets/i18n/brandlift-project';

import {ApiResponse} from 'client/common/store/saga/types';

const i18n = I18N.common.saga.agencyClients;

export function* handleFetchAgencyClients() {
    const res: ApiResponse<typeof getAgencyClients> = yield call(getAgencyClients);

    if (res.status === 200 && res.data) {
        // @ts-ignore
        yield call(handleRequestAgencyClientsSuccess, res.data);
    } else {
        yield call(handleRequestAgencyClientsFailure, res);
    }
}

export function* handleSyncAgencyClients() {
    yield put(clearAgencyClients());

    const res: ApiResponse<typeof syncAgencyClientsRequest> = yield call(syncAgencyClientsRequest);

    if (res.status === 200 && res.data) {
        // @ts-ignore
        yield call(handleRequestAgencyClientsSuccess, res.data);
    } else {
        yield call(handleRequestAgencyClientsFailure, res);
    }
}

export function* handleRequestAgencyClientsSuccess(
    data: GetAgencyClientsResponse['data'] | SyncAgencyClientsResponse['data']
) {
    yield put(setAgencyClients({clients: data}));
}

export function* handleRequestAgencyClientsFailure(res: any) {
    const error = new Error('Error while requesting agency clients');

    // @ts-ignore
    error.data = res.data;

    yield call(logError, {message: 'Error while requesting agency clients', err: error});

    yield put(
        showNotification({
            type: 'error',
            timeOut: 5000,
            message: i18n.error.fetchClients
        })
    );
}

export default function* router() {
    yield takeEvery(fetchAgencyClients, handleFetchAgencyClients);
    yield takeEvery(syncAgencyClients, handleSyncAgencyClients);
}
